import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilserviceService } from 'app/services/utilservice.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  style: any;
  loginForm: FormGroup;
  returnUrl: string;
  loading = false;
  logo: string;
  constructor(private fb: FormBuilder, private util: UtilserviceService, private route: Router, private activatedroute: ActivatedRoute, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.style = this.util.getDomainEnviroment().style;
    window.addEventListener('message', this.receiveCredMessage.bind(this), false);
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });    
    this.activatedroute.queryParams.subscribe(params => {
      let message = params['message'] || null;
      this.returnUrl = params['url'] || null;
      if (message){
        this.toastr.info(message);
      }      
    });
    this.logo = this.util.getDomainEnviroment().landingPageLogo;
  }
  
  async receiveCredMessage(event: MessageEvent){
    await this.util.receiveGoogleAuthToken(event);
  }
  async login(){
    if (this.loginForm.valid) {
      try {
        this.loading = true
        const formValue = this.loginForm.value;
        var data = {
          Email: formValue.email,
          Password: formValue.password
        } 
        var payload = await this.util.login(data);
        if(payload.token){
          this.util.setAuthenticatedUserToken(payload);
          if(this.returnUrl){
            this.route.navigateByUrl(this.returnUrl);
          }else{
            this.route.navigateByUrl("/dashboard");
          }
        }
      } catch (error) {
        this.loading= false;
        console.log(error);
      }finally {
        this.loading= false;
      }
    }
  }
  ngOnDestroy(): void {
    window.removeEventListener('message', this.receiveCredMessage);
  }
}
